import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  inject,
  input,
  signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HangMap } from '@components/hang-map/hang-map.component';
import { SelectDialogContent } from '@components/select-dialog/select-dialog.component';
import { HttpStoreFacade } from '@http/store/facade';
import { DEFAULT_EMPTY_LOCATION } from '@utils/defaults';
import { LatLng, Location } from 'pueblo-types';

@Component({
  selector: 'select-location',
  templateUrl: 'select-location.component.html',
  styleUrl: 'select-location.component.scss',
  imports: [HangMap, MatButtonModule, MatProgressSpinnerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: SelectDialogContent, useExisting: SelectLocation }],
})
export class SelectLocation extends SelectDialogContent {
  private readonly httpStore = inject(HttpStoreFacade);
  private readonly changeDetector = inject(ChangeDetectorRef);

  getSelection(): Location {
    return this.selectedLocation();
  }

  isValid(): boolean {
    return (
      !!this.selectedLocation().coords.lat &&
      !!this.selectedLocation().coords.lng
    );
  }

  readonly location = input<Location>();
  protected readonly selectedLocation = signal<Location>(
    DEFAULT_EMPTY_LOCATION,
  );

  protected readonly userMarkerCoords = toSignal<LatLng | undefined>(
    this.httpStore.userLocation$(),
  );

  constructor() {
    super();

    effect(() => {
      const location = this.location();
      const userMarkerCoords = this.userMarkerCoords();

      if (location) {
        this.selectedLocation.set(location);
      } else if (userMarkerCoords) {
        this.selectedLocation.set({
          displayName: '',
          address: '',
          coords: userMarkerCoords,
        });
      }

      this.changeDetector.markForCheck();
    });
  }

  protected handleLocationSelected(location: Location) {
    this.selectedLocation.set(location);
  }
}
